var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCb003(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 12,
    viewBox: "0 0 134 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2562_21154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.924564L0.238284 1.17238V0.686279L0 0.924564Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5664 0L75.5399 12H76.8047L64.8313 0H63.5664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7715 0L71.7449 12H73.0098L61.0364 0H59.7715Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9688 0L67.9517 12H69.2166L57.2431 0H55.9688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1738 0L64.1473 12H65.4217L53.4387 0H52.1738Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4258 0L60.4088 12H61.6736L49.7002 0H48.4258Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6309 0L56.6043 12H57.8692L45.8957 0H44.6309Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8379 0L52.8113 12H54.0762L42.1028 0H40.8379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.043 0L49.0164 12H50.2813L38.3078 0H37.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.248 0L45.2215 12H46.4864L34.5129 0H33.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4434 0L41.4168 12H42.6912L30.7177 0H29.4434Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6484 0L37.6219 12H38.8868L26.9133 0H25.6484Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8555 0L33.8289 12H35.0938L23.1203 0H21.8555Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0605 0L30.034 12H31.2989L19.3254 0H18.0605Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2656 0L26.2391 12H27.504L15.5305 0H14.2656Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4609 0L22.4344 12H23.7088L11.7353 0H10.4609Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 0L18.6395 12H19.9043L7.93088 0H6.66602Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.87305 0L14.8465 12H16.1114L4.13792 0H2.87305Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.238281 0.686258V1.17236L11.0515 12H12.3164L0.637713 0.295471L0.238281 0.686258Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.238281 4.97538L7.25688 12H8.52174L0.238281 3.7077V4.97538Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.238281 8.77841L3.45276 12H4.72714L0.238281 7.51074V8.77841Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.238281 12H0.923022L0.238281 11.3137V12Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.22 0H131.955L134 2.04925V0.772041L133.22 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.209 0L134.001 5.79508V4.5274L129.483 0H128.209Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.414 0L134 9.60762V8.33042L125.679 0H124.414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.619 0L132.593 12H133.857L121.884 0H120.619Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.824 0L128.798 12H130.063L118.089 0H116.824Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.029 0L125.003 12H126.268L114.294 0H113.029Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.227 0L121.2 12H122.474L110.501 0H109.227Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.432 0L117.405 12H118.67L106.697 0H105.432Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.637 0L113.61 12H114.875L102.902 0H101.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8418 0L109.815 12H111.08L99.1067 0H97.8418Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0469 0L106.02 12H107.285L95.3117 0H94.0469Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2422 0L102.216 12H103.49L91.5166 0H90.2422Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4492 0L98.4227 12H99.6875L87.7141 0H86.4492Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6543 0L94.6277 12H95.8926L83.9192 0H82.6543Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8594 0L90.8328 12H92.0977L80.1242 0H78.8594Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0547 0L87.0377 12H88.3025L76.3291 0H75.0547Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2598 0L83.2332 12H84.5076L72.5246 0H71.2598Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4668 0L79.4402 12H80.7051L68.7317 0H67.4668Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2562_21154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCb003);
export default __webpack_public_path__ + "static/media/cb_003.e5cc7326cd50509090090fba97f5c626.svg";
export { ForwardRef as ReactComponent };